import { render, staticRenderFns } from "./EjsGridWrapper.vue?vue&type=template&id=6c2329fb&"
import script from "./EjsGridWrapper.vue?vue&type=script&lang=js&"
export * from "./EjsGridWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports